<template>
  <div class="user-playlists" v-if="documents">
    <div class="frame" v-if="user">
      <i v-if="!URL" class="fas fa-user-friends text-white"></i>
      <img v-if="URL" :src="URL" alt="">
      <label for="upload" class="text-white"><i class="fas fa-camera text-white"></i>  Upload Your Photo</label>
      <input id="upload" type="file" @change="filechange">
      <div class="user__detail">
        <h2 class="text-white">{{ user.displayName }}</h2>
        <h4 class="text-white">{{ user.email }}</h4>
      </div>
      <div v-if="filerror">{{ filerror }}</div>
    </div>
    <h2 class="text-white">My Playlists</h2>
    <Listview :playlists="documents" />
    <router-link :to="{ name: 'Createplaylist' }" class="btn">Create a New Playlist</router-link>
  </div>
  <div v-else>
    <Spinner />
  </div>
</template>

<script>
import Spinner from '../../components/Spinner'
import getCollection from '../../composables/getCollection'
import getUser from '../../composables/getUser'
import Listview from '../../components/Listview.vue'
import useStorage from '../../composables/useStorage'
import { ref } from 'vue'
import { projectAuth }from '../../firebase/config'

export default {
  components: {
    Listview,
    Spinner
  },
  setup(props, context) {
    const { user } = getUser();
    const { documents } = getCollection('playlists', ['userId', '==', user.value.uid]);
    const file = ref(null);
    const filerror = ref(null);
    const URL = ref(projectAuth.currentUser.photoURL);
    const { uploadFile, url } = useStorage();
    const types = ['image/png', 'image/jpg', 'image/jpeg'];
    const filechange = async (e) => {
      const selected = e.target.files[0];
      if(selected && types.includes(selected.type)){
        file.value = selected;
        await uploadFile(file.value);
        await projectAuth.currentUser.updateProfile({ photoURL: url.value});
        URL.value = projectAuth.currentUser.photoURL;
        console.log(user.value)
      } else {
        file.value = null;
        filerror.value = 'Please select an image file (png or jpg)'
      }
    };
    return { documents, user, filerror, filechange, URL };
  }
}
</script>

<style>
  .frame {
    display: flex;
    margin-bottom: 40px;
    max-width: 800px;
  }
  .frame>i {
   font-size: 64px;
   margin-right: 30px;
  }
  .frame img{
    width: 64px;
    height: 64px;
    object-position: center center;
    object-fit: cover;
    border-radius: 50%;
  }
  .frame input {
    display: none;
  }
  .frame label {
    transform: translate(-12px, 12px);
  }
  .frame label i {
    display: inline-block;
    font-size: 20px;
    vertical-align: bottom;
  }
  .frame .user__detail {
    margin-left: 40px;
  }
  @media only screen and (max-width: 590px) {
    .frame .user__detail {
      margin-left: auto;
    }
  }
</style>